import * as React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ClientsLayout } from './ClientsLayout';
import { CustomersPage } from './Customers/CustomersPage';
import { NewEditPage } from './Customers/NewEdit/NewEditPage';

@observer
class ClientsRouterComponent extends React.Component<any, any> {
    render() {
        return (
            <ClientsLayout>
                <Switch>
                    <Route path='/clients/customers' component={CustomersPage} />
                    <Route path='/clients/neweditcustomer' component={NewEditPage} />
                </Switch>
            </ClientsLayout >
        );
    }
}

const ClientsRouter = withRouter(ClientsRouterComponent)
export default ClientsRouter;